import ChartLayoutSelector from './ChartLayoutSelector';
import { CHART_LAYOUTS, getLayoutById } from '../../utils/chartLayouts';
import { BOARD_TF_OPTIONS } from '../../utils/eodChartMath';

/**
 * TradingView-style right side panel:
 * layout selector · symbol · interval · crosshair · time · date range · options
 */
export default function TvRightPanel({
  layoutId,
  onLayoutChange,
  layoutOpen,
  setLayoutOpen,
  symbolLabel,
  lastPrice,
  changePct,
  tf,
  onTfChange,
  dateRangeId,
  onDateRangeChange,
  dateRanges,
  crosshair,
  clockLabel,
  sessionLabel,
  showFib,
  onToggleFib,
  collapsed,
  onToggleCollapsed,
}) {
  const layout = getLayoutById(layoutId);
  const chgClass = changePct == null ? '' : changePct >= 0 ? 'up' : 'down';

  return (
    <aside className={`tv-right-panel${collapsed ? ' collapsed' : ''}`}>
      <button
        type="button"
        className="tv-right-collapse"
        onClick={onToggleCollapsed}
        title={collapsed ? 'Expand panel' : 'Collapse panel'}
      >
        <i className={`bi bi-chevron-${collapsed ? 'left' : 'right'}`} />
      </button>

      {!collapsed && (
        <>
          <section className="tv-rp-section">
            <div className="tv-rp-label">Layout</div>
            <button
              type="button"
              className="tv-rp-layout-btn"
              onClick={() => setLayoutOpen?.((v) => !v)}
              title="Chart layout"
            >
              <i className="bi bi-grid-3x3-gap" />
              <span>{layout?.title || 'Layout'}</span>
              <i className="bi bi-caret-down-fill tv-rp-caret" />
            </button>
            <ChartLayoutSelector
              value={layoutId}
              open={!!layoutOpen}
              onChange={onLayoutChange}
              onClose={() => setLayoutOpen?.(false)}
            />
            <div className="tv-rp-layout-quick">
              {CHART_LAYOUTS.slice(0, 6).map((l) => (
                <button
                  key={l.id}
                  type="button"
                  className={`tv-rp-quick${layoutId === l.id ? ' active' : ''}`}
                  title={l.title}
                  onClick={() => onLayoutChange?.(l.id)}
                >
                  {l.label}
                </button>
              ))}
            </div>
          </section>

          <section className="tv-rp-section">
            <div className="tv-rp-label">Symbol</div>
            <div className="tv-rp-symbol">{symbolLabel}</div>
            {lastPrice != null && (
              <div className={`tv-rp-price ${chgClass}`}>
                {Number(lastPrice).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                {changePct != null && (
                  <span className="tv-rp-chg">
                    {changePct >= 0 ? '+' : ''}{Number(changePct).toFixed(2)}%
                  </span>
                )}
              </div>
            )}
          </section>

          <section className="tv-rp-section">
            <div className="tv-rp-label">Interval</div>
            <select
              className="tv-rp-select"
              value={tf}
              onChange={(e) => onTfChange?.(e.target.value)}
            >
              {BOARD_TF_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
          </section>

          <section className="tv-rp-section">
            <div className="tv-rp-label">Crosshair</div>
            <div className="tv-rp-mono">
              {crosshair?.price != null
                ? Number(crosshair.price).toLocaleString('en-IN', { maximumFractionDigits: 2 })
                : '—'}
            </div>
            <div className="tv-rp-dim">
              {crosshair?.timeLabel || 'Move over chart'}
            </div>
          </section>

          <section className="tv-rp-section">
            <div className="tv-rp-label">Time</div>
            <div className="tv-rp-mono">{clockLabel || '—'}</div>
            <div className="tv-rp-dim">{sessionLabel || 'NSE 09:15–15:30 IST'}</div>
          </section>

          <section className="tv-rp-section">
            <div className="tv-rp-label">Date range</div>
            <div className="tv-rp-range-list">
              {(dateRanges || []).map((r) => (
                <button
                  key={r.id}
                  type="button"
                  className={`tv-rp-range${dateRangeId === r.id ? ' active' : ''}`}
                  onClick={() => onDateRangeChange?.(r.id)}
                >
                  {r.label}
                </button>
              ))}
            </div>
          </section>

          <section className="tv-rp-section">
            <div className="tv-rp-label">Options</div>
            <label className="tv-rp-check">
              <input type="checkbox" checked={!!showFib} onChange={onToggleFib} />
              Auto Fib
            </label>
          </section>
        </>
      )}
    </aside>
  );
}
